export const APP_REPORT_EVENTS = {
  LOGIN_BUTTON_CLICK: 'login_button_click',
  LOGIN_CODE_SEND_CLICK: 'login_code_send_click',
  LOGIN_CODE_SEND_RESULT: 'login_code_send_result',
  LOGIN_RESULT: 'login_result',
  SIDEBAR_NAV_CLICK: 'sidebar_nav_click',
  LOGOUT_CONFIRM_CLICK: 'logout_confirm_click',
  UPDATE_MODAL_EXPOSED: 'update_modal_exposed',
  UPDATE_DOWNLOAD_START: 'update_download_start',
  UPDATE_INSTALL_CLICK: 'update_install_click',
  UPDATE_INSTALL_START: 'update_install_start',
  UPDATE_DOWNLOAD_RESULT: 'update_download_result',
  DEVICE_BIND_OPEN_CLICK: 'device_bind_open_click',
  DEVICE_BIND_REGENERATE_CLICK: 'device_bind_regenerate_click',
  DEVICE_DELETE_CLICK: 'device_delete_click',
  PRODUCT_MODAL_OPEN_CLICK: 'product_modal_open_click',
  PRODUCT_MODAL_SUBMIT_CLICK: 'product_modal_submit_click',
  PRODUCT_MODAL_APPLY_CLICK: 'product_modal_apply_click',
  PRODUCT_MODAL_ANALYSIS_RESULT: 'product_modal_analysis_result',
  PRODUCT_MODAL_CATEGORY_SAVE_RESULT: 'product_modal_category_save_result',
  PRODUCT_MODAL_COMPETITOR_SAVE_RESULT: 'product_modal_competitor_save_result',
  DOUYIN_ACCOUNT_AUTHORIZE_CLICK: 'douyin_account_authorize_click',
  DOUYIN_ACCOUNT_UNBIND_CLICK: 'douyin_account_unbind_click',
  LEAD_FILTER_CLICK: 'lead_filter_click',
  LEAD_ACCOUNT_SELECT_CLICK: 'lead_account_select_click',
  LEAD_EXTERNAL_LINK_CLICK: 'lead_external_link_click',
  LEAD_FOLLOW_CLICK: 'lead_follow_click',
  LEAD_FOLLOW_RESULT: 'lead_follow_result',
  DASHBOARD_RANGE_CLICK: 'dashboard_range_click',
  DASHBOARD_CATEGORY_CLICK: 'dashboard_category_click',
  DASHBOARD_PRODUCT_CLICK: 'dashboard_product_click',
  DASHBOARD_HOT_VIDEO_CLICK: 'dashboard_hot_video_click',
  DASHBOARD_HOT_VIDEO_DNA_CLICK: 'dashboard_hot_video_dna_click',
  DASHBOARD_HOT_VIDEO_DNA_RESULT: 'dashboard_hot_video_dna_result',
  CONTENT_SCOUT_COMPETITOR_CATEGORY_CLICK: 'content_scout_competitor_category_click',
  CONTENT_SCOUT_COMPETITOR_VIDEO_CLICK: 'content_scout_competitor_video_click',
  CONTENT_SCOUT_COMPETITOR_DETAIL_CLICK: 'content_scout_competitor_detail_click',
  CONTENT_SCOUT_COMPETITOR_DNA_CLICK: 'content_scout_competitor_dna_click',
  CONTENT_SCOUT_COMPETITOR_DNA_RESULT: 'content_scout_competitor_dna_result',
  CONTENT_SCOUT_COMPETITOR_GROUP_VIDEO_CLICK: 'content_scout_competitor_group_video_click',
  CONTENT_SCOUT_COMPETITOR_GROUP_DETAIL_CLICK: 'content_scout_competitor_group_detail_click',
  CONTENT_SCOUT_COMPETITOR_ALL_CLICK: 'content_scout_competitor_all_click',
  CONTENT_SCOUT_CATEGORY_CLICK: 'content_scout_category_click',
  CONTENT_SCOUT_PLATFORM_CLICK: 'content_scout_platform_click',
  CONTENT_SCOUT_SORT_CLICK: 'content_scout_sort_click',
  CONTENT_SCOUT_FILTER_CLICK: 'content_scout_filter_click',
  CONTENT_SCOUT_HOT_VIDEO_CLICK: 'content_scout_hot_video_click',
  CONTENT_SCOUT_HOT_VIDEO_DETAIL_CLICK: 'content_scout_hot_video_detail_click',
  CONTENT_SCOUT_HOT_VIDEO_DNA_CLICK: 'content_scout_hot_video_dna_click',
  CONTENT_SCOUT_HOT_VIDEO_DNA_RESULT: 'content_scout_hot_video_dna_result',
  CREATIVE_WRITER_CHARACTER_GENERATE_FAIL: 'creative_writer_character_generate_fail',
  CREATIVE_WRITER_CHARACTER_REGENERATE_FAIL: 'creative_writer_character_regenerate_fail',
  CREATIVE_WRITER_SHOT_IMAGE_FAIL: 'creative_writer_shot_image_fail',
} as const;

export type AppReportEvent = (typeof APP_REPORT_EVENTS)[keyof typeof APP_REPORT_EVENTS];

export const APP_REPORT_EVENT_TYPES = {
  LOGIN: 'login',
  NAVIGATION: 'navigation',
  AUTH: 'auth',
  UPDATE: 'update',
  ACCOUNT: 'account',
  PRODUCT: 'product',
  LEAD_HUNTER: 'lead_hunter',
  DASHBOARD: 'dashboard',
  CONTENT_SCOUT: 'content_scout',
  CREATIVE_WRITER: 'creative_writer',
} as const;

export type AppReportEventType = (typeof APP_REPORT_EVENT_TYPES)[keyof typeof APP_REPORT_EVENT_TYPES];
